import { Slide, ToastContainer as Container } from 'react-toastify'
import React from 'react'

const ToastContainer = () => {
  return <Container transition={Slide} />
}

export default ToastContainer
